<template>
  <component :is="claimsData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="claimsData === undefined">
      <h4 class="alert-heading">獲取報銷數據時出錯</h4>
      <div class="alert-body">
        找不到相關報銷記錄。請查看
        <b-link class="alert-link" :to="{ name: 'claims-list' }">
          報銷列表
        </b-link>
      </div>
    </b-alert>
    <claims-edit-tab-information
      v-if="claimsData"
      :workerOptions="workerOptions"
      :userOptions="userOptions"
      :approvalStatusOptions="approvalStatusOptions"
      :invoiceOptions="invoiceOptions"
      :paymentMethodOptions="paymentMethodOptions"
      :claims-data="claimsData"
      :claimStatusOptions="claimStatusOptions"
      :is_user_page="is_user_page"
      :role="role"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import claimStoreModule from "../claimStoreModule";
import claimsEditTabInformation from "./claimsEditTabInformation.vue";

export default {
  components: {
    claimsEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  data() {
    return {};
  },
  created() {},
  setup() {
    const claimsData = ref({
      id: 0,
      user_id: null,
      claim_status_id:1,
      payment_method_id: null,
      check_number: null,
      expense_items: [{ id: 0 }],
      documents: [],
    });
    const claims = {
      id: 0,
      user_id: null,
      claim_status_id:1,
      payment_method_id: null,
      check_number: null,
      expense_items: [{ id: 0 }],
      documents: [],
    };

    const claims_APP_STORE_MODULE_NAME = "claims";

    if (!store.hasModule(claims_APP_STORE_MODULE_NAME))
      store.registerModule(claims_APP_STORE_MODULE_NAME, claimStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(claims_APP_STORE_MODULE_NAME))
        store.unregisterModule(claims_APP_STORE_MODULE_NAME);
    });

    const init = ref(true);
    const refetchData = () => {
      if (router.currentRoute.name.indexOf("create") > -1) {
          claimsData.value = claims;
      
          if(init.value){    
            if (router.currentRoute.query.user_id) {
              claimsData.value.user_id = Number(router.currentRoute.query.user_id);
            }
           
            init.value = false;
          }
      } else {
        store
          .dispatch("claims/fetchClaim", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            claimsData.value = response.data.claim;
           
            claimsData.value.expense_items = response.data.claim.expense_items
              ? response.data.claim.expense_items
              : [];
            claimsData.value.documents = response.data.claim.documents
              ? response.data.claim.documents
              : [];
           
          })
          .catch((error) => {
            console.log("error when fetching claims", error);
            if (error.response.status === 404) {
              claimsData.value = undefined;
            }
          });
      }
    };

    const workerOptions = ref([]);
    const userOptions = ref([]);
    const approvalStatusOptions = ref([]);
    const claimStatusOptions = ref([]);
    const invoiceOptions = ref([]);
    const paymentMethodOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          workers: true,
          approve_status: true,
          claim_statuses: true,
          users: true,
          invoices: true,
          receive_methods: true,
        })
        .then((response) => {
          workerOptions.value = response.data.workers;
          approvalStatusOptions.value = response.data.approve_statuses;
          claimStatusOptions.value = response.data.claim_statuses;
          // 只顯示師傅（user_type_id == 4）作為報銷者
          userOptions.value = response.data.users.filter(user => user.user_type_id === 4 || user.user_type_id === 1);
          invoiceOptions.value = response.data.invoices;
          paymentMethodOptions.value = response.data.receive_methods.filter(ele=> ele.id!=18).sort ((a, b) => a.sort_order - b.sort_order);
          refetchData();
        });
    };

   
    const role = ref(null);
    const is_user_page = ref(false);

    onMounted(() => {
      refetchOption();
      role.value = JSON.parse(localStorage.getItem("userData")).role;
      if(router.currentRoute.name.indexOf("worker") > -1){
        is_user_page.value = true;
      }
    });

    return {
      claimsData,
      workerOptions,
      approvalStatusOptions,
      invoiceOptions,
      paymentMethodOptions,
      refetchOption,
      refetchData,
      claimStatusOptions,
      userOptions,
      role,
      is_user_page
    };
  },
};
</script>
